<template>
    <div class="nav-section">
        <div class="nav-content">
            <ul class="tabs tabs-transparent">
                <li class="tab col">
                    <a class="active" href="#env"
                       v-on:click="tabindex='environments'"
                    >Environments</a>
                </li>
                <li class="tab col">
                    <a href="#solution"
                       v-on:click="tabindex='solutions'"
                    >Solutions</a>
                </li>
            </ul>
        </div>
        <NavEnvList
            v-if="tabindex=='environments'"
            v-bind:envpagedata="envpagedata"
            v-on:selectEnvirements="selectEnvirements"
        />
        <NavSolutionsList
            v-if="tabindex=='solutions'"
            v-bind:activeSolutions="activeSolutions"
            v-on:selectEnvirements="selectEnvirements"
        />


        <div
        v-on:click="changeTab()"
        >
        +++
        </div>
    </div>
</template>

<script>
    import M from 'materialize-css'
    import NavEnvList from '@/components/NavEnvList.vue'
    import NavSolutionsList from '@/components/NavSolutionsList.vue'

    export default {
        name: 'NavSection',
        props: ['envpagedata','activeSolutions'],
        data() {
            return {
                inst:{},
                tabindex: 'environments',
                groupenvlist: '',
                environments: this.globalData.environments,
                selectEnv: {},
            }
        },
        mounted() {
            var elem = document.querySelector('.tabs');
            this.inst = M.Tabs.init(elem);

        },
        components:{
            NavEnvList,NavSolutionsList
        },
        methods:{
            selectEnvirements(id){
                this.$emit('selectEnvirements',id)
            },
            changeTab(){
                this.inst.select('solution');
            }
        }
    }
</script>